import {updateEventInRedux} from '@/redux-store/slices/events';
import {store} from '@/redux-store/store';
import keycloakAxios from '@/services/axios';

export const cancelEvent = async (eventId: string) => {
  const response = await keycloakAxios.get(`/event/${eventId}/cancel`);

  if (response.status >= 300) {
    throw new Error(
      `Error cancelling event: Invalid status code: ${response.status}`
    );
  }

  const updatedResponseData = {
    ...response.data,
    price: response.data.price > 0 ? response.data.price / 100 : 0
  };

  store.dispatch(updateEventInRedux({event: updatedResponseData}));

  return updatedResponseData;
};
